module.exports = __webpack_public_path__ + "static/media/automations.88bb170b.jpg";